import React from "react";
import EditDeleteBtn, { EditDeleteYearBtn } from "../button/EditDeleteBtn";

const CardListTwo = ({ title, icon, to, item, type = "Subject" }) => {
	return (
		<div className="bg-white shadow-lg py-6">
			<div>
				<div>
					<div className="max-w-sm mx-auto rounded overflow-hidden cursor-pointer transition transform hover:scale-105 flex justify-center items-center flex-col">
						<div className="w-20 h-20 rounded-full overflow-hidden shrink-0">
							<img
								className="w-full h-full object-cover"
								src={icon}
								alt="Card Img"
							/>
						</div>
						<div className="px-6 py-4">
							{/* <div className="font-bold text-xl mb-2"></div> */}
							<p className="text-[#1B1B1B] text-[20px] font-bold uppercase text-center">
								{title}
							</p>
						</div>
					</div>
				</div>
			</div>
			<div className="mt-6">
				{type === "Year" ? (
					<EditDeleteYearBtn datum={item} />
				) : (
					<EditDeleteBtn datum={item} />
				)}
			</div>
		</div>
	);
};

export default CardListTwo;
